import React from 'react'

const AdvancedKotlin = () => {
  return (
    <div>

        {/* collapseSixtyFive */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSixtyFive">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixtyFive" aria-expanded="false" aria-controls="collapseSixtyFive">
                    Advanced Kotlin <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSixtyFive" className="accordion-collapse collapse" aria-labelledby="headingSixtyFive" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Classes and Objects</li>
                        <li>Functions</li>
                        <li>Custom Constructors</li>
                        <li>Data Classes</li>
                        <li>Inheritance and Overriding</li>
                        <li>Optionals and Null Safety</li>
                        <li>Interface</li>
                        <li>Companion Object</li>
                        <li>Enums</li>
                        <li>Generics</li>
                        <li>Exception Handling</li>
                        <li>Data Type Conversions</li>
                    </ul>
                </div>
            </div>
        </div>



        {/* collapseSixtySeven */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSixtySeven">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixtySeven" aria-expanded="false" aria-controls="collapseSixtySeven">
                    Advanced UI <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSixtySeven" className="accordion-collapse collapse" aria-labelledby="headingSixtySeven" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Scroll Views</li>
                        <li>Scroll View Events</li>
                        <li>Recyclerview Item Touch</li>
                        <li>Fragments</li>
                        <li>Recyclerview in Fragment</li>
                        <li>View Pager</li>
                        <li>Alert Dialogues</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseSixtyEight */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSixtyEight">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixtyEight" aria-expanded="false" aria-controls="collapseSixtyEight">
                    Todo App – Project <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSixtyEight" className="accordion-collapse collapse" aria-labelledby="headingSixtyEight" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Exploring the App</li>
                        <li>New App and the UI</li>
                        <li>Group and Item Rows</li>
                        <li>Data Classes and Initial Data</li>
                        <li>Groups Adapter and ViewHolder</li>
                        <li>Creating New Groups</li>
                        <li>Clicking on a Group</li>
                        <li>Items Activity</li>
                        <li>Items Adapter and ViewHolder</li>
                        <li>Clicking on an Item</li>
                        <li>Adding a New Item</li>
                        <li>Refresh and Delete Groups</li>
                        <li>Adding Animations</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseSixtyNine */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSixtyNine">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixtyNine" aria-expanded="false" aria-controls="collapseSixtyNine">
                    Touches and Animation <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSixtyNine" className="accordion-collapse collapse" aria-labelledby="headingSixtyNine" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Touch Events</li>
                        <li>Touch an Object</li>
                        <li>Single Gesture Detector</li>
                        <li>Touch and Scale</li>
                        <li>View Effects</li>
                        <li>Pixels and Dps</li>
                        <li>Vector Drawables</li>
                        <li>Value Animator</li>
                        <li>Object Animator</li>
                        <li>Animation Listener</li>
                        <li>Animation Set</li>
                        <li>Card Flip Animation</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventy */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventy">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventy" aria-expanded="false" aria-controls="collapseSeventy">
                    Memory Game - Project <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventy" className="accordion-collapse collapse" aria-labelledby="headingSeventy" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Designing Main Activity</li>
                        <li>Square Frame Layout</li>
                        <li>Game Fragment View</li>
                        <li>RecyclerView in Fragment</li>
                        <li>Using RecyclerView</li>
                        <li>Tile Class</li>
                        <li>Three States of Tiles</li>
                        <li>Adding a Tap</li>
                        <li>Basic Game Logic</li>
                        <li>Compare Method</li>
                        <li>Game Won Status</li>
                        <li>Restart</li>
                        <li>Animating the Tiles</li>
                        <li>Dynamic Grid Size</li>
                        <li>Refactoring the Code</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventyOne */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyOne">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyOne" aria-expanded="false" aria-controls="collapseSeventyOne">
                    Android Maps & Location <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyOne" className="accordion-collapse collapse" aria-labelledby="headingSeventyOne" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Maps</li>
                        <li>Map Markers</li>
                        <li>User Location</li>
                        <li>Location Update</li>
                        <li>Drawing a Path</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventyTwo */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyTwo">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyTwo" aria-expanded="false" aria-controls="collapseSeventyTwo">
                    Testing and Debugging <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyTwo" className="accordion-collapse collapse" aria-labelledby="headingSeventyTwo" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Debugging with Log</li>
                        <li>Finding Errors</li>
                        <li>Breakpoints</li>
                        <li>Type of Testing</li>
                        <li>Conditional BreakPoint</li>
                        <li>Testing a UI Component</li>
                        <li>Unit Testing the Todo App</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseSeventyThree */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyThree">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyThree" aria-expanded="false" aria-controls="collapseSeventyThree">
                    Media and Device <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyThree" className="accordion-collapse collapse" aria-labelledby="headingSeventyThree" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Permissions</li>
                        <li>Camera</li>
                        <li>Saving Camera Photos</li>
                        <li>Playing an Audio</li>
                        <li>Sound Recorder</li>
                        <li>Playing a Video</li>
                        <li>Device Orientation</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventyFour */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyFour">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyFour" aria-expanded="false" aria-controls="collapseSeventyFour">
                    MultiTasking <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyFour" className="accordion-collapse collapse" aria-labelledby="headingSeventyFour" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Starting a Thread</li>
                        <li>Threads and Classes</li>
                        <li>Runnables</li>
                        <li>Runnable Interface</li>
                        <li>A Progress Bar</li>
                        <li>Async Task Class</li>
                        <li>Coroutines Intro</li>
                        <li>Permissions</li>
                        <li>Camera</li>
                        <li>Saving Camera Photos</li>
                        <li>Playing an Audio</li>
                        <li>Sound Recorder</li>
                        <li>Playing a Video</li>
                        <li>Device Orientation</li>
                        <li>Coroutine Threads</li>
                        <li>Running Blocking</li>
                        <li>Suspending Functions</li>
                        <li>Coroutines Jobs</li>
                        <li>Coroutines and TimeOut</li>
                        <li>Structured Concurrency</li>
                        <li>Coroutines and Joining Jobs</li>
                        <li>Parallel Decomposition</li>
                        <li>Coroutine Progress Bar</li>
                    </ul>
                </div>
            </div>
        </div>


        {/* collapseSeventyFive */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyFive">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyFive" aria-expanded="false" aria-controls="collapseSeventyFive">
                    Persistent Data <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyFive" className="accordion-collapse collapse" aria-labelledby="headingSeventyFive" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Shared Preferences</li>
                        <li>Saving Files</li>
                        <li>Saving an Array</li>
                        <li>Saving an Image</li>
                        <li>Room Database</li>
                        <li>Room and Coroutines</li>
                        <li>Room - Dependencies</li>
                        <li>Room - Classes and Dao</li>
                        <li>Room - Database</li>
                        <li>Room - Repository</li>
                        <li>Room - ViewModel</li>
                        <li>Room - Implementation</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventySix */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventySix">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventySix" aria-expanded="false" aria-controls="collapseSeventySix">
                    Todo List in Room - Project <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventySix" className="accordion-collapse collapse" aria-labelledby="headingSeventySix" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Adding Dependencies</li>
                        <li>Updated Data Classes</li>
                        <li>DAO Interface</li>
                        <li>Database</li>
                        <li>Updated AppData</li>
                        <li>If Database Exists</li>
                        <li>Reading from Room</li>
                        <li>Saving to Room</li>
                        <li>New Group</li>
                        <li>Updated Groups Adapter</li>
                        <li>Updated Items Activity</li>
                        <li>Updated Items Adapter</li>
                        <li>Inserting an Item</li>
                        <li>Deleting an Item</li>
                        <li>Updating an Item</li>
                        <li>Deleting a Group</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventySeven */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventySeven">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventySeven" aria-expanded="false" aria-controls="collapseSeventySeven">
                    Networking and Web <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventySeven" className="accordion-collapse collapse" aria-labelledby="headingSeventySeven" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Web View</li>
                        <li>Youtube Video</li>
                        <li>Json and XML</li>
                        <li>Retrofit - Api</li>
                        <li>Retrofit - Reading Raw</li>
                        <li>Retrofit - Arguments</li>
                        <li>Retrofit - Data Class</li>
                        <li>Retrofit – Coroutine</li>
                        <li>Flicker App</li>
                        <li>Flicker App - Dependencies</li>
                        <li>Flicker App - UI</li>
                        <li>Flicker App - Flicker Api</li>
                        <li>Flicker App - Data classes</li>
                        <li>Flicker App - Api Interface</li>
                        <li>Flicker App - Repository Object</li>
                        <li>Flicker App - Adapter</li>
                        <li>Flicker App - Photos ViewModel</li>
                        <li>Flicker App - Observer</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventyEighth */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyEighth">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyEighth" aria-expanded="false" aria-controls="collapseSeventyEighth">
                    FireBase <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyEighth" className="accordion-collapse collapse" aria-labelledby="headingSeventyEighth" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Firebase Console</li>
                        <li>Firebase Project</li>
                        <li>UI Setup</li>
                        <li>Register</li>
                        <li>Login</li>
                        <li>Write Simple Data</li>
                        <li>Read Simple Data</li>
                        <li>Write an Object</li>
                        <li>Read an Object</li>
                        <li>Write Many Objects</li>
                        <li>Read Many Objects</li>
                        <li>Reading Continuously</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventyNine */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyNine">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyNine" aria-expanded="false" aria-controls="collapseSeventyNine">
                    Monetization <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyNine" className="accordion-collapse collapse" aria-labelledby="headingSeventyNine" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Google Admob</li>
                        <li>Google AdSense</li>
                        <li>Facebook Ad Network</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseSeventyEighty */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyEighty">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyEighty" aria-expanded="false" aria-controls="collapseSeventyEighty">
                    Playstore <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyEighty" className="accordion-collapse collapse" aria-labelledby="headingSeventyEighty" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Publish App to Playstore</li>
                        <li>Update App on Playstore</li>
                        <li>Playstore Content Writing</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseEightyOne */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingEightyOne">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEightyOne" aria-expanded="false" aria-controls="collapseEightyOne">
                    Cloud Todo List – Project <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseEightyOne" className="accordion-collapse collapse" aria-labelledby="headingEightyOne" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Firebase Project</li>
                        <li>Auth and Database</li>
                        <li>User Status</li>
                        <li>Register User</li>
                        <li>Login User</li>
                        <li>Logout User</li>
                        <li>UI Feedback</li>
                        <li>Item on Cloud</li>
                        <li>Empty Group on Cloud</li>
                        <li>Existing Group on Cloud</li>
                        <li>Delete Item from Cloud</li>
                        <li>Delete Group from Cloud</li>
                        <li>Class to Map</li>
                        <li>Map to Class</li>
                        <li>Read Online Data</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseEightyTwo */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingEightyTwo">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEightyTwo" aria-expanded="false" aria-controls="collapseEightyTwo">
                    Git and Github <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseEightyTwo" className="accordion-collapse collapse" aria-labelledby="headingEightyTwo" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Create Repository</li>
                        <li>Push and Pull</li>
                        <li>Clone and Fork</li>
                        <li>Branches and Merge Branch</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseEightyThree */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingEightyThree">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEightyThree" aria-expanded="false" aria-controls="collapseEightyThree">
                    Jenkins – CI/CD Pipeline <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseEightyThree" className="accordion-collapse collapse" aria-labelledby="headingEightyThree" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Jenkins Console</li>
                        <li>Plugins and settings , configurations</li>
                        <li>SSH and key pair file</li>
                        <li>Free Style projects</li>
                        <li>Jenkins Console</li>
                        <li>Plugins and settings, configurations</li>
                        <li>SSH and key pair file</li>
                        <li>Free Style projects</li>
                        <li>Build, Test, Deploy Stages</li>
                        <li>JenkinsFile</li>
                    </ul>
                </div>
            </div>
        </div>

        {/* collapseEightyFour */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingEightyFour">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEightyFour" aria-expanded="false" aria-controls="collapseEightyFour">
                    JIRA <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseEightyFour" className="accordion-collapse collapse" aria-labelledby="headingEightyFour" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Agile Methodologies</li>
                        <li>Scrum</li>
                        <li>Sprints</li>
                        <li>Todo , Processing , Completed Status</li>
                        <li>Backlogs</li>
                        <li>Bug Tracking</li>
                    </ul>
                </div>
            </div>
        </div>













    </div>
  )
}

export default AdvancedKotlin